import { useEffect } from 'react';

// Best-effort native orientation lock. Only works in fullscreen / installed
// (standalone) contexts - browsers ignore it in a normal tab, where the CSS
// rotation-lock in App.css (@media orientation: landscape) takes over instead.
function useLockPortrait() {
  useEffect(() => {
    const orientation = window.screen.orientation;
    if (orientation?.lock) {
      orientation.lock('portrait').catch(() => {});
    }
  }, []);
}

export default useLockPortrait;
